import MuiBox, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

export interface FlexBoxProps extends Omit<MuiBoxProps, 'display'> {}

export const FlexBox = (props: FlexBoxProps) => {
  const { sx, ...restProps } = props;
  return <MuiBox {...restProps} sx={[...toSxArray(sx), { display: 'flex' }]} />;
};
